export default __webpack_public_path__ + "static/media/yo_4.3757b0b0.mp3";